<script>
    export let headline;
    export let subheadline;
    export let icon;
</script>
<div>
    <h2>{icon}</h2>
    <h3>{headline}</h3>
    {#if subheadline !== 'routes.owner.metrics.cols.4.subheadline'}
    <p>{subheadline}</p>
    {:else}
    <img src="https://assets.auting.it/images/reale-mutua/black.png" alt="Reale Mutua Logo" />
    {/if}
</div>

<style>
    div {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        flex: 1;
        width: 100%;
        height: auto;
    }

    h3 {
        text-align: center;
        margin: 0;
        padding: 0;
    }

    p {
        text-align: center;
        margin: 0;
        padding: 0;
    }

    h2 {
        font-size: 32px;
        margin: 0;
        padding: 0;
    }

    img {
        height: 18px;
        margin: 0;
        padding: 0;
    }

    @media (max-width: 768px) {
        div {
            padding-bottom: 40px;
            justify-content: flex-start;
        }

        p {
            margin-top: -8px;
        }

        img {
            margin-top: -6px;
        }
    }
</style>